<script>
// eslint-disable-next-line no-unused-vars
import Firebase from 'firebase'

export const firebaseApp = Firebase.initializeApp({
 
//DATI DB SORIN
  // Populate your firebase configuration data here.
  // Initialize Firebase
/*
    apiKey: "AIzaSyBjqgen__nC1COpHTptfUL8p6yHJE46TaM",
    authDomain: "jestionale-bb779.firebaseapp.com",
    databaseURL: "https://jestionale-bb779.firebaseio.com",
    projectId: "jestionale-bb779",
    storageBucket: "jestionale-bb779.appspot.com",
    messagingSenderId: "562674471908"
*/

//DATI DB BRENNO
/*
    apiKey: "AIzaSyBQ1wUkrkUUqiaPT-op3Dx9CFZzio6gLn0",
    authDomain: "jestionale-7f717.firebaseapp.com",
    databaseURL: "https://jestionale-7f717.firebaseio.com",
    projectId: "jestionale-7f717",
    storageBucket: "jestionale-7f717.appspot.com",
    messagingSenderId: "139291840460"*/

//DATI DB APP.JESTIONALE
    apiKey: "AIzaSyAzrO4oQMpjINS5vmDbWHYHReLeWblhFbE",
    authDomain: "jestionale-bfde2.firebaseapp.com",
    databaseURL: "https://jestionale-bfde2.firebaseio.com",
    projectId: "jestionale-bfde2",
    storageBucket: "jestionale-bfde2.appspot.com",
    messagingSenderId: "951799802642"
});

//questi oggetti esportati vengono utilizzati ovunque tranne in vuex per mantenere la retrocompat.
export const db = firebaseApp.database()
export const storage = firebaseApp.storage()
export const auth = firebaseApp.auth()

export default {
  name: 'Firebase_Conn'
}
</script>





